import React from 'react'
import { BiChevronRight } from 'react-icons/bi'
import RouterHook from '../../../contexts/RouterHook'
import { UsuarioContext } from '../../../contexts/UsuarioContext'
import { IoChevronBackOutline } from 'react-icons/io5'
import { ExcluirDados } from '../../Modais'

import './stylesAL.css'

export default function AspectLegal() {
  const serverRouter = RouterHook()
  const { userUCtx } = React.useContext(UsuarioContext)

  const [modalED, setModalED] = React.useState(false)

  function handleBackButtonEvent() {
    serverRouter('back')
  }

  React.useEffect(() => {
    document.title = 'Aspectos Legais | Agendei Quadras'
    window.history.pushState(null, null, window.location.pathname)
    window.addEventListener('popstate', handleBackButtonEvent)
    return () => {
      window.removeEventListener('popstate', handleBackButtonEvent)
    }
  }, [])

  const bttsList = [
    {
      label: 'Termos de Uso',
      onClick: () => {
        window.open('https://www.agendeiquadras.com.br/termos.html', '_blank')
      },
    },
    {
      label: 'Política de Privacidade',
      onClick: () => {
        window.open(
          'https://www.agendeiquadras.com.br/politica-de-privacidade-agendei-quadras.html',
          '_blank',
        )
      },
    },
    {
      label: 'Política de Cookies',
      onClick: () => {
        window.open('https://www.agendeiquadras.com.br/politica-de-cookies.html', '_blank')
      },
    },
    {
      label: 'Exclusão de Dados',
      onClick: () => {
        setModalED(true)
      },
    },
    {
      label: 'Solicitar cópia dos meus dados',
      onClick: () => {
        const email = 'dados@agendeiquadras.com.br'
        const subject = encodeURIComponent('Solicitação de Cópia de Dados')
        const body = encodeURIComponent(
          `Solicito receber uma cópia dos meus dados cadastrados na plataforma Agendei Quadras. \n \n ID: ${userUCtx.usuario.idusuario} \n Nome: ${userUCtx.usuario.nome} \n Email: ${userUCtx.usuario.username}`,
        )
        const mailto = `mailto:${email}?subject=${subject}&body=${body}`

        window.location.href = mailto
      },
    },
  ]
  //Componente que renderiza os botões de acesso aos aspectos legais
  function BttCompAspects({ data }) {
    return (
      <button className='btt-acess-aspects-legais' onClick={data.onClick}>
        <h2>{data.label}</h2>
        <BiChevronRight className='btt-icon-aspects' size={30} />
      </button>
    )
  }

  return (
    <div className='contain-aspect-legais-desktop'>
      {modalED && <ExcluirDados show={modalED} onClose={() => setModalED(false)} />}
      <IoChevronBackOutline className='icon-back-aspects' onClick={() => serverRouter('back')} />
      <h1>Aspectos Legais</h1>
      <div className='contain-line-aspects' />
      <div className='contain-list-acess-aspects-legais'>
        {bttsList.map((item, index) => (
          <React.Fragment key={index}>
            <BttCompAspects data={item} />
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}
